import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import './About.css';

function About() {
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    // Fetch the data from the JSON file using Axios
    axios.get('/data/data.json')
      .then((response) => {
        setAboutData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching about data:', error);
      });
  }, []);

  if (!aboutData) {
    return <div style={{textAlign: 'center'}}>Loading About...</div>; // Loading state until the data is fetched
  }

  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false 
  };

  return (
    <section className="about section" id="about">
      <h2 data-heading="My Intro" className="section__title">About Me</h2>

      <div className="about__container container grid">
        {/* Left side: Image Slider */}
        <div className="about__slider">
          <Slider {...settings}>
            {aboutData.aboutImage.map((image, index) => (
              <img key={index} src={image.url} alt={`About Image ${index + 1}`} className="about__img" />
            ))}
          </Slider>
        </div>

        {/* Right side: About Content */}
        <div className="about__data">
          <h3 className="about__heading">Hi, I'm {aboutData.name}</h3>
          <p className="about__description">{aboutData.aboutDescription}</p>
          <div className="about__info grid">
            {aboutData.achievements.map((achievement, index) => (
              <div key={index} className="about__box">
                <i className={`uil ${achievement.icon} about__icon`}></i>
                <h3 className="about__title">{achievement.title}</h3>
                <span className="about__subtitle">{achievement.subtitle}</span>
              </div>
            ))}
          </div>
          <a href={aboutData.cvLink} className="button" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-navigator button__icon"></i>Download CV
          </a>
        </div>
      </div>
    </section>
  );
}

export default About;
